import { ISearchPagination } from '../internal/domain/entities/SearchPaginationCatalog';
import {
    ISearchResult,
    ISortOption,
    INavigationItem,
    INavigationFilter,
    IRefinement,
    IBreadCrumbItem,
    IBreadcrumbFilter,
    ITypeaheadResult,
    IDimensionSearchValues,
    IItemTypeahead,
    IProdObjListItem,
    IContentObjListItem
} from '../internal/interfaces/ISearchInterfaces';
import { ENDECA_REDIRECT } from '../internal/constants/Search';

const DataMappings = {
    results: {
        response(resp: ISearchResult) {
            if (resp.hasOwnProperty(ENDECA_REDIRECT)) {
                const {
                    'endeca:redirect': {
                        link: { url }
                    }
                } = resp;

                return { url };
            } else {
                const {
                    resultsList: {
                        records,
                        sortOptions,
                        recsPerPage,
                        totalNumRecs,
                        firstRecNum,
                        lastRecNum,
                        pagingActionTemplate: { link: paginationLink }
                    },
                    navigation: { navigation },
                    breadcrumbs: { refinementCrumbs },
                    searchAdjustments: { adjustedSearches, originalTerms }
                } = resp;

                const pagination: ISearchPagination = {
                    recsPerPage,
                    totalNumRecs: totalNumRecs || 0,
                    firstRecNum: firstRecNum || 0,
                    lastRecNum: lastRecNum || 0,
                    link: paginationLink.replace(/&jsonp=jsonp/g, '')
                };

                const contentObjListItems: IContentObjListItem[] = [];
                const prodObjListItems: IProdObjListItem[] = [];

                records.forEach(record => {
                    if (
                        record.attributes.content &&
                        record.attributes.content.length > 0 &&
                        record.attributes.content[0] === 'true'
                    ) {
                        const content: IContentObjListItem = {
                            type: record.attributes.type[0],
                            nId: record.attributes.c_node_id[0],
                            articles: record.records
                        };
                        contentObjListItems.push(content);
                    } else {
                        const product: IProdObjListItem = {
                            productId: record.attributes.p_product_id[0],
                            defaultSkuId: record.attributes.s_sku_id[0],
                            skuIds: record.attributes.s_sku_id
                        };
                        prodObjListItems.push(product);
                    }
                });

                const sortByOptions = sortOptions.map(
                    (item: ISortOption): ISortOption => {
                        const { label, selected } = item;
                        let { link } = item;
                        link = link.replace(/.jsonp=jsonp/g, '');

                        return {
                            link,
                            label,
                            selected
                        };
                    }
                );

                const navigationFilters = navigation.map(
                    (item: INavigationItem): INavigationFilter => {
                        const { dimensionName, refinements } = item;
                        const refinementsValues = refinements.map(
                            (refinementItem: IRefinement): IRefinement => {
                                const { label, count } = refinementItem;
                                let { link } = refinementItem;
                                link = link.replace(/.jsonp=jsonp/g, '');

                                return {
                                    label,
                                    link,
                                    count
                                };
                            }
                        );

                        return {
                            dimensionName,
                            refinementsValues
                        };
                    }
                );

                const breadcrumbsFilters = refinementCrumbs.map(
                    (item: IBreadCrumbItem): IBreadcrumbFilter => {
                        const { dimensionName, label, removeAction } = item;
                        let { link } = removeAction;
                        link = link.replace(/.jsonp=jsonp/g, '');

                        return {
                            dimensionName,
                            label,
                            link,
                            removeAction
                        };
                    }
                );

                let adjustedTerm = '';

                if (adjustedSearches) {
                    const originalTerm = originalTerms[0];
                    if (adjustedSearches[originalTerm][0].spellCorrected) {
                        adjustedTerm = adjustedSearches[originalTerm][0].adjustedTerms;
                    }
                }

                return {
                    prodObjListItems,
                    contentObjListItems,
                    sortByOptions,
                    pagination,
                    navigationFilters,
                    breadcrumbsFilters,
                    totalNumRecs,
                    lastRecNum,
                    firstRecNum,
                    adjustedTerm
                };
            }
        }
    },
    typeahead: {
        response(resp: ITypeaheadResult) {
            const { children } = resp;
            const { dimensionSearchGroups } = children[0];
            const dimensionsTypeahead = dimensionSearchGroups.map(
                (item: IDimensionSearchValues) => {
                    const { dimensionSearchValues } = item;

                    const dimensionTypeahead = dimensionSearchValues.map(
                        (dimensionProp: IItemTypeahead) => {
                            const { label, count } = dimensionProp;

                            let { link } = dimensionProp;

                            link = link.replace(/.jsonp=jsonp/g, '');

                            return {
                                label,
                                link,
                                count
                            };
                        }
                    );

                    return dimensionTypeahead;
                }
            );

            return dimensionsTypeahead;
        }
    }
};

export default DataMappings;
